// extracted by mini-css-extract-plugin
export var actions = "_19-0";
export var actionsContainer = "_19-7";
export var border = "_19-1";
export var childFullHeight = "_19-f";
export var collapse = "_19-2";
export var content = "_19-a";
export var contentChild = "_19-e";
export var fullscreen = "_19-c";
export var hasLeftRadius = "_19-k";
export var headerContainer = "_19-3";
export var headerRow = "_19-5";
export var hidePadding = "_19-b";
export var navCollapsedGap = "_19-l";
export var noScrollX = "_19-m";
export var noScrollY = "_19-n";
export var noTopPadding = "_19-i";
export var optOutTopPadding = "_19-d";
export var pageMain = "_19-j";
export var pageOuter = "_19-g";
export var pagePadding = "_19-8";
export var pageScroll = "_19-9";
export var profile = "_19-o";
export var profileContainer = "_19-p";
export var profileImage = "_19-q";
export var profileMain = "_19-r";
export var profileSubtitle = "_19-t";
export var profileTitle = "_19-s";
export var showLeftPadding = "_19-h";
export var tabsPortalSlot = "_19-6";
export var tabsWrapper = "_19-4";
export var title = "_19-u";